// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QwQt","title":"styles_title__1BPv9"};